import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear()
    return (
        <div className='footer'>
            <p>Help desk: <a href="mailto:wojciech.piotrowicz@softwebo.pl">wojciech.piotrowicz@softwebo.pl</a></p>
            <p>© <a href="https://softwebo.pl/" target='_blank' rel="noreferrer">Softwebo</a> 2022 - {currentYear}</p>
        </div>
    )
}

export default Footer;